// extracted by mini-css-extract-plugin
export default {"root":"LoginPage_root__nWyfe"};